/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
import { ColumnBinarySearch } from "./ColumnBinarySearch.mjs";
import { ColumnIndex } from "./ColumnIndex.mjs";
export function buildColumnSearchStrategy(dependencyGraph, config, statistics) {
  if (config.useColumnIndex) {
    return new ColumnIndex(dependencyGraph, config, statistics);
  } else {
    return new ColumnBinarySearch(dependencyGraph);
  }
}